import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/site/Nav";
import { Footer } from "./components/site/Footer";
import { WhatsAppFab } from "./components/site/WhatsAppFab";
import { SmoothScroll } from "./components/site/SmoothScroll";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import Admin from "./pages/admin/Admin";

const PublicLayout = () => (
  <>
    <Nav />
    <Outlet />
    <Footer />
    <WhatsAppFab />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/negozio" element={<Shop />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/chi-sono" element={<About />} />
          <Route path="/contatti" element={<Contact />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
